import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import UserProfile from "users/information/profile-information/user-profile";
import NetworkInvitationInfoSchema, { NetworkInvitationInfoJSON, NetworkInvitationInfoParams } from "users/networking/connections/invitations/_schemas/network-invitation-info-schema";

export default class NetworkInvitationInfo {
  public static readonly EXAMPLE = NetworkInvitationInfo.create({
    id: Guid.generate(),
    status: "pending",
    inviter: true,
    individualId: Guid.generate(),
    user: UserProfile.EXAMPLE,
    created: new AHDate(),
    message: "Test invitation message"
  });

  public static create(values: NetworkInvitationInfoParams): NetworkInvitationInfo {
    const parsed = NetworkInvitationInfoSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid NetworkInvitationInfo parameters.");
    }
    return new NetworkInvitationInfo(parsed);
  }

  public static fromJSON(json: NetworkInvitationInfoJSON): NetworkInvitationInfo {
    if (isNullOrUndefined(json)) return json;
    const params = NetworkInvitationInfoSchema.deserialize(json);
    return new NetworkInvitationInfo(params);
  }

  public static fromJSONArray(
    jsonArray: NetworkInvitationInfoJSON[]
  ): NetworkInvitationInfo[] {
    if (isNullOrUndefined(jsonArray)) return jsonArray;
    return jsonArray.map(json => NetworkInvitationInfo.fromJSON(json));
  }

  public readonly id: Guid;
  public readonly status: string;
  public readonly inviter: boolean;
  public readonly individualId: Guid;
  public readonly avatarId?: Guid;
  public readonly user: UserProfile;
  public readonly created: AHDate;
  public readonly message: string;

  public constructor(params: NetworkInvitationInfoParams) {
    this.id = params.id;
    this.status = params.status.toLowerCase();
    this.inviter = params.inviter;
    this.individualId = params.individualId;
    this.avatarId = params.avatarId;
    this.user = UserProfile.create(params.user);
    this.created = params.created;
    this.message = params.message ?? "";
  }

  public toJSON(): NetworkInvitationInfoJSON {
    return NetworkInvitationInfoSchema.serialize(this);
  }

  public isEqualTo(other: NetworkInvitationInfo): boolean {
    return this.id.isEqualTo(other?.id);
  }

  public toString(): string {
    return `NetworkInvitationInfo (
      id: ${this.id.value},
      status: ${this.status},
      inviter: ${this.inviter.toString()},
      individualId: ${this.individualId.value},
      avatarId: ${this.avatarId?.value},
      user: ${this.user.toString()},
      created: ${this.created.toString()},
      message: ${this.message}
    )`;
  }
}
